import './App.css'
import CharacterInput from './components/CharacterInput'
// Replace your code here
const App = () => <CharacterInput />

export default App
